interface LogoSectionProps {
  primaryLogoUrl: string;
  secondLogoUrl?: string;
  primaryLogoAnchorLink?: string;
}

const LogoSection = ({ primaryLogoUrl, secondLogoUrl, primaryLogoAnchorLink }: LogoSectionProps) => {
  const isLinkValid = primaryLogoAnchorLink && primaryLogoAnchorLink.trim() !== '';

  const LogoContainer = isLinkValid ? 'a' : 'div';
  const href = isLinkValid
    ? primaryLogoAnchorLink.startsWith('http')
      ? primaryLogoAnchorLink
      : `https://${primaryLogoAnchorLink}`
    : undefined;

  return (
    <LogoContainer {...(isLinkValid ? { href, target: '_blank', rel: 'noreferrer' } : {})} className="logo d-block">
      <img alt="logo" src={primaryLogoUrl} />
      {secondLogoUrl && (
        <>
          <span className="divider divider-header-logos d-md-none"></span>
          <img className="secondary-logo-mobile d-md-none" alt="secondary-logo" src={secondLogoUrl} />
        </>
      )}
    </LogoContainer>
  );
};

export default LogoSection;
